module.exports = __webpack_public_path__ + "04_medium_black.f96d5434.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_medium_black.png
// module id = H62f
// module chunks = 0